import React from "react";

function FilterClose() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Path_19902"
        data-name="Path 19902"
        d="M14,26A12,12,0,1,1,26,14,12,12,0,0,1,14,26Zm0-2.4A9.6,9.6,0,1,0,4.4,14,9.6,9.6,0,0,0,14,23.6Zm0-11.3,3.394-3.394,1.7,1.7L15.7,14l3.394,3.394-1.7,1.7L14,15.7l-3.394,3.394-1.7-1.7L12.3,14,8.909,10.606l1.7-1.7Z"
        transform="translate(-2 -2)"
        fill="#bcbcbc"
      />
    </svg>
  );
}

export default FilterClose;
